module.exports = __webpack_public_path__ + "static/media/down-arrow-white.276529cb.svg";